<template>
    <div class="w-100 d-flex flex-column">

        <div class="btn-group mt-1 w-100 position-sticky top" style="z-index: 999; background-color: #e6e6e6;">
            <b-button variant="outline-secondary"
                      @click="changeAllStatus(locationIdList,true)"
                      v-if="showListLength === 0 || activated < showListLength && activated >= 0">
                全选
            </b-button>
            <b-button variant="outline-secondary"
                      @click="changeAllStatus(locationIdList,false)"
                      v-if="showListLength === 0 || activated > 0">
                清空
            </b-button>
        </div>

        <div class="btn-group-vertical mt-1 mb-1 w-100">
            <template v-for="item in locationIdList">
                <button type="button" class="btn text-truncate w-100" :class="btnStyle(item)"
                        data-toggle="tooltip"
                        :title="item.label"
                        :key="item.id"
                        :id="item.id"
                        v-if="item.show"
                        @click="switchLocationSelectStatus(item)">
                    {{ item.label }}
                    <span v-if="itemPos.locationId===item.id" class="badge badge-light position-absolute right">
                        <div class="font-weight-bold">></div>
                    </span>
                </button>
            </template>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import "@/components/echarts-part/CalendarShift/cells/stuffs/positions.css";

export default {
    name: "LoadRateActiveLocationList",
    props: {
        locationIdList: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activated: -1,
            hasChangedStatus: false,
            activeIds: [],
            lazyLoad: false,
        }
    },
    watch: {
        itemPos(val) {
            if (val !== null) {
                let el = document.getElementById(val.locationId);
                if (el !== null) {
                    el.scrollIntoView({block: 'center', behavior: 'smooth'})
                }
            }
        },
        locationIdList: {
            deep: true,
            handler() {
                if (this.locationIdList.length > 0) {
                    this.activated = 0;
                    for (let item of this.locationIdList) {
                        if (item.active && item.show) {
                            this.activated++;
                        }
                    }
                    if (this.lazyLoad && this.hasChangedStatus) {
                        let tempList = [];
                        for (let item of this.locationIdList) {
                            if (item.active) {
                                tempList.push(item.id);
                            }
                        }
                        this.activeIds = tempList;
                        this.saveCustomStatus();
                    }
                } else {
                    this.activated = -1;
                }
            },
            immediate: true,
        },
        showLocationIdSet() {
            for (let item of this.locationIdList) {
                item.show = this.showLocationIdSet == null || this.showLocationIdSet.has(item.id);
            }
        }
    },
    computed: {
        ...mapState({
            showLocationIdSet: state => state.calendarShift.showLocationIdSet
        }),
        remoteData() {
            return this.$store.getters["calendarShift/scheduledData"];
        },
        itemPos() {
            let pos = this.$store.state.calendarShift.itemPos;
            return pos == null ? {locationId: '', dateStr: ''} : pos;
        },
        showListLength() {
            let temp = 0;
            for (let item of this.locationIdList) {
                if (item.show) {
                    temp++;
                }
            }
            return temp;
        }
    },
    mounted() {
        this.loadCustomizedStatus();
        this.lazyLoad = true;
    },
    beforeDestroy() {
        this.saveCustomStatus();
    },
    methods: {
        btnStyle(item) {
            return item.overFlow ? (item.active ? 'btn-danger' : 'btn-outline-danger') : (item.active ? 'btn-success' : 'btn-outline-success');
        },
        switchLocation(locationId) {
            for (let item of this.locationIdList) {
                if (item.id === locationId) {
                    this.switchLocationSelectStatus(item);
                    return;
                }
            }
        },
        switchLocationSelectStatus(item) {
            this.changeAllStatus(Array.of(item), !item.active);
        },
        changeAllStatus(list, status) {
            this.hasChangedStatus = true;
            let tempList = [];
            for (let item of list) {
                if (item.show) {
                    if (status && !item.active) {
                        tempList.push(item);
                    }
                    item.active = status;
                    if (!item.active && item.id === this.itemPos.locationId) {
                        this.$store.commit('calendarShift/setItemOff', true)
                    }
                }
            }
            this.emitEvent(tempList);
        },
        emitEvent(value) {
            setTimeout(() => this.$emit('activeChange', value), 300);
        },
        customLocalStorageKey() {
            return 'load-rate-active-location';
        },
        saveCustomStatus() {
            if (this.hasChangedStatus) {
                localStorage[this.customLocalStorageKey()] = JSON.stringify(this.activeIds);
            }
        },
        loadCustomizedStatus() {
            let customizedStatus = localStorage[this.customLocalStorageKey()];
            if (customizedStatus !== undefined && customizedStatus != null) {
                let tempList = JSON.parse(customizedStatus);
                for (let item of this.locationIdList) {
                    item.active = !!tempList.some(f => f === item.id);
                }
            }
        },
    }
}
</script>

<style scoped>
.btn-group-cover {
    overflow-y: auto;
}

.btn-group-cover::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}

.right {
    right: 0.2rem;
    top: 0.25rem !important;
}

.btn-outline-success:hover {
    background-color: #ffffff;
    color: #28a745;
}
</style>
